namespace Matrix.Data {
    export interface TestGroupTestForm {
        TestGroupCode: Serenity.LookupEditor;
        TestCode: Serenity.LookupEditor;
        SequenceNumber: Serenity.DecimalEditor;
        ParameterBinding: Serenity.LookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TestGroupTestForm extends Serenity.PrefixedContext {
        static formKey = 'Data.TestGroupTest';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TestGroupTestForm.init)  {
                TestGroupTestForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(TestGroupTestForm, [
                    'TestGroupCode', w0,
                    'TestCode', w0,
                    'SequenceNumber', w1,
                    'ParameterBinding', w0,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
